import script from "./PopUpMask.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopUpMask.vue?vue&type=script&setup=true&lang=ts"

import "./PopUpMask.vue?vue&type=style&index=0&id=843105a4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-843105a4"]])

export default __exports__